export const EXTENSION_TYPE_NAME = 'gif';

//# sourceMappingURL=constants.js.map